// bajaResolucion.js — P3-9b (remate). ¿Una foto de producto queda BAJA DE RESOLUCIÓN
// una vez encuadrada a 4:5? El tema sirve la foto de producto hasta 1600 px de ANCHO;
// por debajo se ve blanda en escritorio. El criterio NO mira el ancho bruto sino el
// ancho EFECTIVO tras el encuadre 4:5: una foto más ancha que 4:5 pierde los lados y
// queda con ancho = alto·0,8 (1700×1900 bruto → 1520 encuadrada → baja resolución).
// Informativo: NO bloquea nada ni cambia el criterio de optimización. Frontend-only.
export const UMBRAL_NITIDEZ = 1600;

// Ancho efectivo tras encuadrar a 4:5 (4:5 ⇒ ancho = alto·0,8 si la foto es más ancha).
export function anchoEncuadrado45(ancho, alto) {
  return Math.round(Math.min(Number(ancho) || 0, (Number(alto) || 0) * 0.8));
}

export function esBajaResolucion(ancho, alto) {
  return anchoEncuadrado45(ancho, alto) < UMBRAL_NITIDEZ;
}
